import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'chargeType', pure: false, standalone: true })
export class ChargeTypePipe extends BaseEnumTranslationPipe<string> implements PipeTransform {
  protected readonly translationPrefix = 'iss-wo-common.charge-type';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
